
enum SearchCompanyEnumEnum {
    byName = "byName",
    byId = "byId",
}

export { SearchCompanyEnumEnum };